import { render, staticRenderFns } from "./ICalendar.vue?vue&type=template&id=4db4f7d8&scoped=true&"
import script from "./ICalendar.vue?vue&type=script&lang=js&"
export * from "./ICalendar.vue?vue&type=script&lang=js&"
import style0 from "./ICalendar.vue?vue&type=style&index=0&id=4db4f7d8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db4f7d8",
  null
  
)

export default component.exports